var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8334 17.96C13.866 18.4985 13.4585 18.9626 12.9204 19H11.0804C10.5422 18.9626 10.1348 18.4985 10.1674 17.96V15.94C7.95034 15.1168 6.48494 12.9949 6.50038 10.63C6.46483 7.55667 8.92706 5.03624 12.0004 5C15.0737 5.03624 17.5359 7.55667 17.5004 10.63C17.5158 12.9949 16.0504 15.1168 13.8334 15.94V17.96Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8334 15.9399H10.1674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOff);
export default __webpack_public_path__ + "static/media/light-off.27257532604195237858316a4016f062.svg";
export { ForwardRef as ReactComponent };